import * as Sentry from '@sentry/browser';
import BaseInterceptor from '@/router/interceptors/BaseInterceptor.js';
import sessionMonitor from '@/services/SessionMonitor.js';

class UnauthenticatedInterceptor extends BaseInterceptor {
    async handle(status) {
        const publicPaths = ['/', '/login', '/password/email', '/password/reset'];
        const currentPath = this.$router.currentRoute.value.path;

        const routeIncluded = publicPaths.some(
            path => currentPath === path || (path !== '/' && currentPath.startsWith(`${path}/`))
        );

        if (routeIncluded) {
            sessionMonitor.reset();
            return true;
        }

        if (status !== 401) {
            return false;
        }

        // Concurrent 401s after the first expiry — already handled
        if (sessionMonitor.isSessionTimedOut() || sessionMonitor.isRedirectInProgress()) {
            return true;
        }

        // Expected when the user was never authenticated this session
        if (!this.$store.getters['Auth/check']) {
            return true;
        }

        if (currentPath && !publicPaths.includes(currentPath)) {
            this.$store.dispatch('Auth/saveReturnPath', currentPath);
        }

        try {
            sessionMonitor.handleSessionTimeout();
        } catch (error) {
            console.error('SessionMonitor.handleSessionTimeout() threw an error:', error);

            Sentry.captureException(error, {
                tags: {
                    error_type: 'session_timeout_handler_failed',
                    component: 'UnauthenticatedInterceptor',
                },
                contexts: {
                    session: {
                        current_path: currentPath,
                        session_monitor_available: true,
                    },
                },
            });
        }

        this.$store.dispatch('Auth/setSessionTimedOut', true);

        return true;
    }
}

export default UnauthenticatedInterceptor;
